import { useCallback, useContext, useState } from "react";
import { CalculatorContext } from "./calculatorContext";

export function CalculatorProvider({children}){
    const [calculatorInfo, setCalculatorInfo] = useState({
        id: null,
        distance: 0,
        time: {
            hour: 0,
            minute: 0
        },
        month: null,
        vehicle: null,
        days: 0,
        batta: true,
        perKm: 0
    });

    const [sharedData, setSharedData] = useState([]);

    const updateTripName = useCallback((name) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            tripName: name
        }));
    }, []);

    const updateDistance = useCallback((distance) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            distance: distance
        }));
    }, []);

    const updateTime = useCallback((time) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            time: time
        }));
    }, []);

    const updateCoordinates = useCallback((locations) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            locations: locations
        }));
    }, []);

    const updateMapData = useCallback((distance, hours, minute) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            distance: distance,
            time: {
                hour: hours,
                minute: minute
            }
        }));
    }, []);

    const updateFiltersData = useCallback((month, vehicle, days, batta, id) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            id: id,
            month: month,
            vehicle: vehicle,
            days: days,
            batta: batta
        }));
    }, []);

    const updatePerKmRate = useCallback((perKm) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            perKm: perKm
        }));
    }, []);

    const clearCalculator = useCallback(() => {
        setCalculatorInfo({
            id: null,
            distance: 0,
            time: {
                hour: 0,
                minute: 0
            },
            month: null,
            vehicle: null,
            days: 0,
            batta: true,
            perKm: 0
        });
    }, []);

    const updateSharedData = useCallback((response) => {
        setSharedData(response);
    }, []);

    const filterSharedData = useCallback((tag) => {
        let amount = 0;

        for(let i = 0; i < sharedData.length; i++){
            if(sharedData[i].tag === tag){
                amount = sharedData[i].amount;
            }
        }

        return amount;
    }, [sharedData]);

    const value = {
        calculatorInfo,
        updateMapData,
        updateFiltersData,
        updatePerKmRate,
        clearCalculator,
        updateDistance,
        updateTripName,
        updateCoordinates,
        updateTime,

        sharedData,
        updateSharedData,
        filterSharedData
    }

    return (
        <CalculatorContext.Provider value={value}>
            {children}
        </CalculatorContext.Provider>
    );
}

export const GetCalculatorInfo = () => {
    return useContext(CalculatorContext);
};